import { Link } from 'react-router-dom';

export default function AboutPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <div className="p-8 md:p-12 flex flex-col justify-center">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4">关于狠狠爱</h2>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                「狠狠爱」诞生于一个简单的信念：每个人都值得被深爱，每个人都有能力去深爱。
                我们相信，真正的爱不是小心翼翼的试探，而是全力以赴的奔赴。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-6">
                无论你正在寻找爱自己的方法、爱他人的勇气，还是爱的表达方式，
                这里都有真诚的文字和温暖的故事陪伴你。让每一份情感，都燃烧得更有意义。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 self-start whitespace-nowrap"
              >
                了解更多
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            </div>
            <div className="relative min-h-[300px] lg:min-h-full">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20inviting%20cozy%20reading%20nook%20with%20a%20comfortable%20armchair%20soft%20throw%20blanket%20a%20wooden%20bookshelf%20filled%20with%20books%20and%20a%20small%20vase%20of%20dried%20flowers%20on%20a%20side%20table%20gentle%20sunlight%20streaming%20through%20sheer%20curtains%20cream%20and%20warm%20beige%20tones%20peaceful%20atmosphere%20editorial%20interior%20photography&width=800&height=600&seq=about-preview-home-02&orientation=landscape"
                alt="关于狠狠爱"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}